import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenStore } from './token.store';

export const adminAuthGuard: CanActivateFn = () => {
  const tokens = inject(TokenStore);
  return tokens.access || tokens.refresh ? true : inject(Router).createUrlTree(['/admin/login']);
};
